import { normalizeKey } from "../formatters/strings.formatter";


/**
 * Converter genérico para atributos string que quieres en lower-case.
 */
export const lowerStringConverter = {
    fromAttribute: (v: string | null) => (v == null ? '' : normalizeKey(v)),
    toAttribute: (v: string) => v ?? ''
} as const;
